import { UserSupportingCompany } from '@interfaces';

export type UserSupportingCompanyState = Readonly<{
  loadingCompaniesSupportedByUser: boolean;
  companiesSupportedByUser: UserSupportingCompany[] | null;

  loadingUsersSupportingCompany: boolean;
  usersSupportingCompany: UserSupportingCompany[] | null;

  updateInProgress: boolean;
  errorMessage: any;
}>;

export const initialState: UserSupportingCompanyState = {
  loadingCompaniesSupportedByUser: false,
  companiesSupportedByUser: null,

  loadingUsersSupportingCompany: false,
  usersSupportingCompany: null,

  updateInProgress: false,
  errorMessage: null,
};
